import { api } from '@/api/api';
import { apis } from '@/config';
import { getOs } from './../../../utils/confOs';
const ADVERT_CLOSE_PREFIX = 'advert_close_';
const ADVERT_PREV_CLOSE_TIME = 'advert_prev_close_time_';
export function advert_sign(version) {
    let fill = (function (tbl) {
        return function (num, n) {
            return 0 >= n + String(num).length ? num : (tbl[n] || (tbl[n] = Array(n + 1).join('0'))) + num;
        };
    })([]);
    const randomNum = new Date().getTime() * Math.random() * 10000;
    let key = `${Math.abs(Math.floor(randomNum))}`;
    let sum = 0;
    for (let i = 0; i < key.length; i++) {
        sum += parseInt(key.charAt(i));
    }
    sum += key.length;
    const fillSum = fill(sum, 3 - sum.toString().length);
    return version.toString() + key + fillSum;
}
class AdvertApiImpl {
    constructor() {
        this.version = '1';
        this.name = apis.advertApiImpl;
        this.httpApi = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
        this.dataStore = api.getDataStoreApi();
    }
    init() {
        return this.name;
    }
    parseResult(res) {
        return res.data;
    }
    catchError(reason) {
        return reason;
    }
    async fetchConfig(spaceCode) {
        const sign = advert_sign(this.version);
        const option = {
            advertSpaceCode: spaceCode,
            _r: sign,
        };
        const url = this.systemApi.getUrl('getAdvertResources');
        return this.httpApi.get(url, option).then(this.parseResult).catch(this.catchError);
    }
    async track(info) {
        const _r = advert_sign(this.version);
        const url = info.trackUrl + '&_platform=' + AdvertApiImpl.cur_platform;
        if (url && url.length > 0) {
            return this.httpApi.post(url, { _r }).then(this.parseResult).catch(this.catchError);
        }
    }
    getTrackInfo(items) {
        if (!items || items.length === 0) {
            return null;
        }
        const viewTrack = items.find(item => item.type === 'VIEW');
        const clickTrack = items.find(item => item.type === 'CLICK');
        const downloadTrack = items.find(item => item.type === 'DOWNLOAD');
        return {
            trackViewUrl: viewTrack ? viewTrack.trackUrl : '',
            trackClickUrl: clickTrack ? clickTrack.trackUrl : '',
            trackDownloadUrl: downloadTrack ? downloadTrack.trackUrl : '',
        };
    }
    async getAdvertInfo(spaceCode) {
        return this.fetchConfig(spaceCode)
            .then(res => {
            if (res && res.data && res.data.itemList && res.data.itemList.length > 0) {
                const items = res.data.itemList;
                items.sort((a, b) => {
                    return b.sort - a.sort;
                });
                const firstItem = items[0];
                const firstAdResource = firstItem.advertResourceList[0];
                if (firstAdResource) {
                    const advertInfo = {
                        autoFetchIntervalSecond: firstItem.autoFetchIntervalSecond || 0,
                        id: firstAdResource.id,
                        clickUrl: firstAdResource.content.clickUrl || '',
                        title: firstAdResource.content.title || '',
                        clickContent: firstAdResource.content.clickContent || '',
                    };
                    const trackInfo = this.getTrackInfo(firstAdResource.outsideStatisticsList);
                    if (trackInfo) {
                        advertInfo.trackViewUrl = trackInfo.trackViewUrl;
                        advertInfo.trackClickUrl = trackInfo.trackClickUrl;
                        advertInfo.trackDownloadUrl = trackInfo.trackDownloadUrl;
                    }
                    return advertInfo;
                }
            }
            return null;
        })
            .catch(err => {
            console.error('获取广告信息失败:', err);
            return null;
        });
    }
    makeAdvertCloseKey(advertId) {
        if (!advertId || advertId.length === 0) {
            return '';
        }
        return ADVERT_CLOSE_PREFIX + advertId;
    }
    makeAdvertPrevCloseTimeKey(advertId) {
        if (!advertId || advertId.length === 0) {
            return '';
        }
        return ADVERT_PREV_CLOSE_TIME + advertId;
    }
    getAdvertCloseCount(advertId) {
        const defaultCount = 0;
        try {
            const key = this.makeAdvertCloseKey(advertId);
            const data = this.dataStore.getSync(key);
            if (data && data.suc && data.data) {
                return Number.parseInt(data.data) || defaultCount;
            }
            return defaultCount;
        }
        catch (ex) {
            console.error('获取广告关闭次数失败:', ex);
            return defaultCount;
        }
    }
    closeAdvert(advertId) {
        try {
            if (!advertId || advertId.length === 0) {
                return;
            }
            const count = this.getAdvertCloseCount(advertId);
            const key = this.makeAdvertCloseKey(advertId);
            const newCount = count + 1;
            this.dataStore.putSync(key, newCount.toString());
            const prevCloseTimeKey = this.makeAdvertPrevCloseTimeKey(advertId);
            const now = new Date().getTime();
            this.dataStore.putSync(prevCloseTimeKey, now.toString());
        }
        catch (ex) {
            console.error('关闭广告失败:', ex);
        }
    }
    getShouldShowAdvert(advertId, maxCount, spanTime) {
        const prevCloseTimeKey = this.makeAdvertPrevCloseTimeKey(advertId);
        const prevCloseTime = this.dataStore.getSync(prevCloseTimeKey);
        if (prevCloseTime && prevCloseTime.suc && prevCloseTime.data) {
            const prevTime = Number.parseInt(prevCloseTime.data);
            const now = new Date().getTime();
            const diffTime = now - prevTime;
            if (diffTime < spanTime) {
                return false;
            }
        }
        const count = this.getAdvertCloseCount(advertId);
        if (count >= maxCount) {
            return false;
        }
        return true;
    }
}
AdvertApiImpl.cur_platform = getOs();
const advertApiImpl = new AdvertApiImpl();
api.registerLogicalApi(advertApiImpl);
export default advertApiImpl;
